import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { unassignPHNumber } from "../../../apiclients/streamsapi_bridge.js";
import { useNavigate } from "react-router";

const UnassignPhoneNumbers = (props) => {
    const [isloading, setIsloading] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    async function unassignThisNumber(e) {
        console.log("value is :::22222222222222222222222::: ");
        // alert("value is :::11111111111111111::: "+props);
        // alert("value is :::::: "+props.phoneNum);
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let update = {
            reqid: 15,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            unassign_phnum: props.phoneNum
        };
        console.log("json request ::::::::: " + JSON.stringify(update));
        setIsloading(true);
        let unassign = await unassignPHNumber(update);
        setIsloading(false);
        let unassingMsg = await unassign.json();
        console.log("Response... ");
        console.log(unassingMsg);
        //props.onUnassign('tab2');
        if (unassingMsg.status == "Failed") {
            localStorage.setItem(
                "f_message",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            navigate("/PhoneNumbers", {
                state: { tab: "tab1" },
            });
        } else {
            if (unassingMsg?.message?.errors) {
                const errorObj = unassingMsg.message.errors[0]
                console.log(`err object in  UpdateAccPinCID is :::::: ${JSON.stringify(errorObj)}`);
                if (errorObj && errorObj.message)
                    localStorage.setItem("f_message", errorObj.message);


            } else {
            localStorage.setItem("s_message", "Phone Number unassigned successfully.");
            navigate("/PhoneNumbers", {
                state: { tab: "tab1"},
              });
            }
        }
        window.location.reload();
    }
    // async function confirmDelete() {
    //     console.log(props.phoneNum);
    //     console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    //     let update = {
    //         siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //         confirm: false,
    //         deleted_ph_nums: props.phoneNum
    //     };
    //     console.log(update);
    //     let deletenum = await deletePHNumber(update);
    //     let deleteMsg = await deletenum.json();
    //     console.log("Response... ");
    //     console.log(deleteMsg);

    // }
    // useEffect(() => {
    //     confirmDelete();

    // }, []);

    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {(props.isnineoo) ?
            <>
             <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 mb-3 rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="unlink" className="me-3" size="lg" color="danger" />
                <span>{t("NineooUnassingPhonetxt")}</span>
            </div>
            <MDBModalFooter className="p-0 pt-2">
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("ok")}
                </MDBBtn>
            </MDBModalFooter>
            </> :
            <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 mb-3 rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="unlink" className="me-3" size="lg" color="danger" />
                <span>{t("UnassingPhonetxt")}</span>
            </div>
            <MDBModalFooter className="p-0 pt-2">
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => unassignThisNumber(e)}>{t("unassign")}</MDBBtn>
            </MDBModalFooter>
            </>
            
            }
            
        </>
    );
};

export default UnassignPhoneNumbers;
